<div class="version-container">
  <!-- APP VERSION: API VERSION -->

  Version: {{ APP_Version() }}&nbsp;:&nbsp;{{ API_Version() }}
</div>
